import chevronIcon from "assets/icons/chevronIcon.svg"
import { useGraphqlQuery } from "graphql-mock"
import { ProgressBar } from "materia"
import { Stars } from "../../../components/Stars"
import { useNavigateBack } from "../../../tools/useNavigateBack"
import { usePageTitle } from "../../../tools/usePageTitle"
import { BundleHeaderError } from "./error"
import { query } from "./gql"
import { BundleHeaderSkeleton } from "./loading"

import s from "./styles.module.scss"

export const BundleHeaderConnected = ({ id }: { id: string }) => {
  const { data, error, isPending } = useGraphqlQuery(query, { id })

  const { productBundle } = data ?? {}
  const { progress, title = null } = productBundle ?? {}
  const {
    certifiedCount = 0,
    certifiedMax = 0,
    starsCount = 0,
    starsMax = 0,
  } = progress ?? {}

  // TODO https://jira.attensi.com/browse/WEB-19512
  // Changing a page title is currently a bit clunky - it needs this hook.
  // It would be nice to show the bundle's name as the page title, and this
  // is the first place where we fetch that name - ProductBundleView would
  // be a more natural place for it, but it's not aware of API.
  usePageTitle(title ?? null)

  return (
    <BundleHeader
      isLoading={isPending}
      error={error}
      bundleDetails={{
        title,
        certifiedCount,
        certifiedMax,
        starsCount,
        starsMax,
      }}
    />
  )
}

type BundleDetails = {
  title: string | null
  certifiedCount: number
  certifiedMax: number
  starsCount: number
  starsMax: number
}
type BundleHeaderProps = {
  isLoading: boolean
  error: unknown
  bundleDetails: BundleDetails
}
export const BundleHeader = ({
  isLoading,
  error,
  bundleDetails: { title, certifiedCount, certifiedMax, starsCount, starsMax },
}: BundleHeaderProps) => {
  const navigateBack = useNavigateBack()

  if (isLoading) return <BundleHeader.Skeleton />
  if (error) return <BundleHeader.Error error={error} />

  const isBundleWithScore = starsMax > 0

  return (
    <div className={s.header}>
      <div className={s.header__centered}>
        <div className={s.header__widgetLayoutSize}>
          <button className={s.header__back} onClick={() => navigateBack()}>
            <img className={s.header__backIcon} src={chevronIcon} alt="" />
          </button>
          <div className={s.header__title}>{title}</div>
          {isBundleWithScore && (
            <>
              <div className={s.header__progress}>
                <ProgressBar
                  value={certifiedCount}
                  maxValue={certifiedMax}
                  color="purple-60"
                  backgroundColor="purple-10"
                />
              </div>
              <div className={s.header__stars}>
                <Stars
                  count={1}
                  max={1}
                  size="extraSmall"
                  ariaLabel={`${starsCount} of ${starsMax}`}
                />
                {starsCount}/{starsMax}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

BundleHeader.Skeleton = BundleHeaderSkeleton
BundleHeader.Error = BundleHeaderError
